




































































































import { plainToClass } from "class-transformer";
import { uniqueId } from "lodash";
import { Component, Inject, Mixins, Prop } from "vue-property-decorator";
import { NavigationGuardNext, Route } from "vue-router";
import MaltaModule, { MODULE_ID, PORTAL_TARGET } from "../../index";
import BeforeUnload from "../../mixins/BeforeUnload";
import ProjectProposalMixin from "../../mixins/ProjectProposal";
import Utils from "../../mixins/Utils";
import { StandardOutput, StandardOutputs } from "../../models/ProjectProposal";
import FormConfirmBeforeDelete from "../private/forms/FormConfirmBeforeDelete.vue";
import FormDirtyOnLeavePage from "../private/forms/FormDirtyOnLeavePage.vue";
import FormUploadFile from "../private/forms/FormUploadFile.vue";

@Component({
    beforeRouteLeave(this: ProjectProposalStandardOutputsList, to: Route, from: Route, next: NavigationGuardNext<Vue>) {
        this.isDirty ? (this.showModal = true) : next();
    },
    components: {
        FormDirtyOnLeavePage,
        FormUploadFile,
        FormConfirmBeforeDelete
    }
})
export default class ProjectProposalStandardOutputsList extends Mixins(ProjectProposalMixin, Utils, BeforeUnload) {
    @Inject(MODULE_ID) maltaModule!: MaltaModule;
    @Prop({ required: true }) standardOutputs!: StandardOutputs;
    @Prop({ required: true }) loading!: boolean;

    showModal = false;
    isDirty = false;
    isValid: string[] = [];
    showDelete = false;
    itemToRemove: StandardOutput | null = null;

    backToHome() {
        this.goHome();
    }

    async saveAndGoBack() {
        this.isValid = this.standardOutputs.isValid;
        this.$emit("save");
    }

    get portalTarget(): string {
        return PORTAL_TARGET;
    }

    isValidRow(index: number): boolean {
        return this.isValid.findIndex(e => e.startsWith(`standardOutputs.${index}.`)) === -1;
    }

    addRow(): void {
        const standardOutput = plainToClass(StandardOutput, {
            standard_output_id: +uniqueId() * -1
        } as StandardOutput);
        this.standardOutputs.standardOutputs.push(standardOutput);
        this.$router.push({
            name: "project-proposal-standard-output-edit",
            params: {
                itemId: standardOutput.standard_output_id.toString()
            }
        });
    }

    removeRow(item: StandardOutput): void {
        this.itemToRemove = item;
        this.showDelete = true;
    }

    removeRowConfirmed(): void {
        this.standardOutputs.standardOutputs = this.standardOutputs.standardOutputs.filter(
            i => this.itemToRemove && i.standard_output_id !== this.itemToRemove.standard_output_id
        );
    }

    editRow(item: StandardOutput): void {
        this.$router.push({
            name: "project-proposal-standard-output-edit",
            params: {
                itemId: item.standard_output_id.toString()
            }
        });
    }
}
